<template>
<div class="trainingReportBox">
    <div class="reportPage one_page">
        <div class="noPrintModel" style="height: 30px;"></div>
        <div class="firstTit">
            <h3>党建培训日志（修订）</h3>
        </div>
        <div class="twoTitinfo">
            <p>
                <span>时间：{{timeFrom.formattedDate}}</span>
                <span>{{timeFrom.dayOfWeek}}</span>
                <span>上课地点：{{tableFrom.address}}</span>
            </p>
            <p>
                <span>主教官：{{tableFrom.userName}} 班主任：{{tableFrom.masterName}}</span>
            </p>
        </div>
        <table>
            <tr>
                <td style="width: 80px;">课程</td>
                <td colspan="3">{{tableFrom.name}}</td>
                <td style="width: 80px;">主讲教官</td>
                <td style="width: 100px;" colspan="2">{{tableFrom.userName}}</td>
                <td style="width: 80px;">辅助教官</td>
                <td style="text-align: left;">{{tableFrom.userName2}}</td>
            </tr>
            <tr>
                <td>应到人数</td>
                <td style="min-width: 30px;">{{ tableFrom.ydCount }}</td>
                <td style="width: 90px;">实到人数</td>
                <td style="min-width: 30px;">{{tableFrom.sdCount}}</td>
                <!-- <td colspan="2">请假人员姓名及原因</td>
                <td colspan="3">{{ tableFrom.qjMsg }}</td> -->
                <td style="position: relative;" colspan="5">
                    <div class="supplementModel">
                        <div>请假人员姓名及原因</div>
                        <div>
                            <span>{{ tableFrom.leaveReason }}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td>教学准备</td>
                <td class="textCon" colspan="6">
                    <p>拟授科目的学员分析：</p>
                    <p style="margin: 10px 0px;">{{tableFrom.jxzbStudent}}</p>
                    <p>拟授科目教学目标：</p>
                    <p style="margin: 10px 0px;">{{tableFrom.jxzbTarget}}</p>
                </td>
                <td>训练器材及场地需求</td>
                <td style="text-align: left;">{{tableFrom.jxzbEquipment}}</td>
            </tr>
            <tr>
                <td>教学实施</td>
                <td class="textCon" colspan="6">
                    <p>采取的教学方法：</p>
                    <p style="margin: 10px 0px;">{{tableFrom.jxssMethod}}</p>
                    <p>教学步骤：</p>
                    <p style="margin: 10px 0px;">{{tableFrom.jxssStep}}</p>
                </td>
                <td>训练中学员普遍反映的问题</td>
                <td style="text-align: left;">{{tableFrom.jxssQuestion}}</td>
            </tr>
            <tr>
                <td>教学例会主要内容</td>
                <td class="textCon" colspan="6">
                    <p>训练中存在的问题：</p>
                    <p style="margin: 10px 0px;">{{tableFrom.jxlxQuestion}}</p>
                    <p>教学效果较差的内容：</p>
                    <p style="margin: 10px 0px;">{{tableFrom.jxlxContent}}</p>
                </td>
                <td class="textCon" colspan="2">
                    <p>优秀学员：{{tableFrom.highStudent}}</p>
                    <p>不合格学员：{{tableFrom.lowStudent}}</p>
                    <p>需补课学员及科目：{{tableFrom.otherCnt}}</p>
                </td>
            </tr>
        </table>
        <div class="tableFootInfo">
            <p>上下课时间：{{ tableFrom.timeBegin }} ~ {{ tableFrom.timeEnd }}</p>
            <p>新疆公安厅政治部教育训练处制表</p>
        </div>
    </div>
</div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'trainingReport',
    props:['infoFrom','timeFrom'],
    data(){
        return {
            tableFrom:{}
        }
    },
    created(){
        this.tableFrom = this.infoFrom;
    },
    methods:{
        getFrom(val){
            this.tableFrom = val;
        },
    }
}
</script>

<style lang="less" scoped>
h1,h2,h3{
    padding: 0px;
    margin: 0px;
}
.trainingReportBox{
    position: relative;
    margin: 0;
    padding: 20px 0px;
    background-color: #f2f2f2;

    .reportPage{
        width: 190.5mm;
        min-height: 247mm;
        margin: auto;
        margin-bottom: 20px;
        box-shadow: 1px 1px 8px #e2e2e2;
        background-color: #fff;
        box-sizing: border-box;
        padding: 20px 45px;
    }

    .one_page{
        font-family: '宋体';
        .firstTit{
            width: 100%;
            text-align: center;
            padding-bottom: 10px;
            h3{
                font-family: '宋体';
                font-size: 26px;
            }
        }
        .twoTitinfo{
            text-align: right;
            font-family: '宋体';
            font-size: 16px;

            p{
                padding-bottom: 6px;
                span + span{
                    margin-left: 10px;
                }
            }
        }
        table{
            width: 100%;
            border-collapse: collapse;
            font-family: '宋体';
            font-size: 16px;
            tr{
                text-align: center;
                th{
                    padding: 10px;
                }
                td{
                    padding: 10px 4px;
                    border: 1px solid #000;
                }
                .textCon{
                    text-align: left;
                }
            }
        }
        .tableFootInfo{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 5px 0px;
        }
    }
}

.supplementModel{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    &>div{
        box-sizing: border-box;
        padding: 4px 4px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    &>div:nth-child(1){
        flex-shrink: 0;
        border-right: 1px solid #000;
        padding: 4px 8px;
    }
    &>div:nth-child(2){
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
}

.showPrintModel{
    display: none;
}

@media print {
    @page {
        size: 210mm 297mm; /* or size: 794px 1123px; */
    }
    *,body,#app{
        padding: 0px;
        margin: 0px;
    }
    .trainingReportBox{
        background-color: #fff;
    }
    .reportPage{
        box-shadow: none !important;
        margin-bottom: 0px !important;
        padding: 0px !important;
    }
    .noPrintModel{
        display: none;
    }
    .showPrintModel{
        display: block;
    }
}
</style>